<template>
    <div class="component dashboard">
        <h1>Dashboard</h1>
        <pre v-if="debug">
            {{ $store.getters.serial }}
            {{ $store.getters.localUrl }}
            {{ $store.getters.publicKey }}
            {{ $store.getters.encryptedPrivateKey }}
        </pre>
        <div class="iconspace">
            <div v-for="icon in icons"
                 :class="'icon '+icon.route"
                 @click="navigate( icon.route )">
                <div class="icon-title">{{ icon.title }}</div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Dashboard',
    data()
    {
        return {
            icons: [
                {
                    route: 'status',
                    title: 'Aktueller Status'
                },
                {
                    route: 'logs',
                    title: 'Logbuch'
                },
                {
                    route: 'boost',
                    title: '15 Minuten Zirkulation'
                },
                {
                    route: 'vacancy',
                    title: 'Urlaubsmodus'
                },
                {
                    route: 'heating',
                    title: 'Wärmeerzeugung'
                },
                {
                    route: 'delivery',
                    title: 'Wärmeverteilung'
                },
                {
                    route: 'settings',
                    title: 'Einstellungen'
                }
            ],
            debug: false
        }
    },
    methods: {
        navigate( route )
        {
            this.$router.push( { name: route } )
        }
    }
}
</script>